<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import {
  getPackageById,
  updatePackage,
} from "../../../api/services/package.service";
import { newPackageObject } from "./package-controller";
import { getS3SingedUrl } from "../../../api/services/general.service";
import PackageImageCroperModel from "../../../components/models/package-image-crop";

export default {
  props: {
    visible: Boolean,
    closeable: Boolean,
    packageID: String,
  },
  components: {
    "package-image-cropper-model": PackageImageCroperModel,
  },
  data() {
    return {
      packageId: null,
      packageTitle: null,
      packageDescription: null,
      packageLongDescription: null,
      packageTitleImageURL: null,
      packagePriority: null,
      editPackageProcessing: false,
      editPackageSuccess: false,
      editPackageFailed: false,
      croppedPackageImage: null,
      showPackageImageCropModel: null,
    };
  },
  validations: {
    packageTitle: { required },
    packageDescription: { required },
    packageLongDescription: { required },
    packagePriority: { required }
  },
  computed: {
    showModal: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  async mounted() {
    this.packageId = this.packageID;
    await this.getPackage(this.packageId);
  },
  methods: {
    async getPackage(packageId) {
      let getPackageToEdit = await getPackageById(packageId);
      if (getPackageToEdit) {
        this.packageTitle = getPackageToEdit.title;
        this.packageTitleImageURL = getPackageToEdit.titleImage;
        this.packageDescription = getPackageToEdit.description;
        this.packageLongDescription = getPackageToEdit.longDescription;
        this.packagePriority = getPackageToEdit.priority;
      }
    },
    async clickSavePackageButton() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.editPackageProcessing = true;
        let editedPackageObject_Pass = new newPackageObject();
        editedPackageObject_Pass.packageTitle = this.packageTitle;
        editedPackageObject_Pass.packageDescription = this.packageDescription;
        editedPackageObject_Pass.packageLongDescription = this.packageLongDescription;
        editedPackageObject_Pass.packageTitleImageURL = this.packageTitleImageURL;
        editedPackageObject_Pass.packagePriority = Number(this.packagePriority);

        if (this.croppedPackageImage) {
          const packageImageFile = this.$refs.packageImageInput.files[0];
          const croppedPackageImage = this.croppedPackageImage;
          const finalPackageImageToPass = await new Promise(function (resolve) {
            return croppedPackageImage.toBlob(resolve, packageImageFile.type);
          });
          const fileName = packageImageFile.name;
          let getUploadedImageURL = await getS3SingedUrl(fileName);

          let getFileUploadResponse = await axios.put(
            getUploadedImageURL.signedUrl,
            finalPackageImageToPass
          );

          if (getFileUploadResponse) {
            let fileBaseUrl =
              "https://s3.eu-central-1.amazonaws.com/ms-sissi.uploads/";
            editedPackageObject_Pass.packageTitleImageURL =
              fileBaseUrl + fileName;
          }
        }

        let packageEditSuccess = await updatePackage(
          this.packageId,
          editedPackageObject_Pass
        );

        if (packageEditSuccess) {
          this.editPackageProcessing = false;
          this.editPackageSuccess = true;
          this.$emit("reload");
        } else if (!packageEditSuccess) {
          this.editPackageProcessing = false;
          this.editPackageFailed = true;
        }
      } else {
        this.editPackageProcessing = false;
        console.log("Validation Error"); //eslint-disable-line
      }
    },
    packageImageSelected() {
      const imagePreviewCanvers = this.$refs.packageImageCanvas;
      const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
      imagePreviewCanversContext.clearRect(
        0,
        0,
        imagePreviewCanvers.width,
        imagePreviewCanvers.height
      );

      const packageImageFile = this.$refs.packageImageInput.files[0];
      this.openCorpPackageImageModel(packageImageFile);
    },
    openCorpPackageImageModel(packageImageFile) {
      this.packageImageFileToCrop = packageImageFile;
      this.showPackageImageCropModel = true;
    },
    setCroppedImageToPreview(croppedImage) {
      const imagePreview = this.$refs.packageImagePreview;
      const imagePreviewCanvers = this.$refs.packageImageCanvas;
      if (imagePreview && imagePreviewCanvers.getContext) {
        const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
        imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 450, 240);
      }
      this.croppedPackageImage = croppedImage;
      this.showPackageImageCropModel = false;
    },
    clickCloseButton() {
      this.$emit("reload");
    },
  },
};
</script>

<template>
  <!-- Edit Company Model-->
  <b-modal
    v-model="showModal"
    :title="this.$i18n.t('packages.editPackage.title')"
    centered
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    scrollable
  >
    <div class="row">
      <!-- Edit Sucees and Failed Msg -->
      <div class="col-md-12">
        <b-alert v-model="editPackageSuccess" variant="success" dismissible
          ><i class="mdi mdi-check-all mr-2"></i
          >{{ $t("packages.editPackage.editSuccessMsg") }}</b-alert
        >
        <b-alert v-model="editPackageFailed" variant="danger" dismissible
          ><i class="bx bx-error-circle mr-2"></i
          >{{ $t("packages.editPackage.editFailedMsg") }}</b-alert
        >
        <b-alert v-model="editPackageProcessing" variant="info"
          ><i class="bx bx-loader-alt bx-spin mr-2"></i
          >{{ $t("packages.editPackage.editProcessing") }}</b-alert
        >
      </div>

      <!--- Subpackage Image -->
      <div class="col-md-12 mb-5 mt-3">
        <div class="avatar-md mr-4">
          <span
            ref="packageImagePreview"
            class="subpackage-image-preview-after-crop"
          >
            <canvas
              id="packageImageCanvas"
              ref="packageImageCanvas"
              height="240"
              width="450"
            ></canvas>
            <span
              v-if="!this.croppedPackageImage"
              class="avatar-title bg-white"
              style="margin-left: -450px"
            >
              <img
                v-if="this.packageTitleImageURL"
                :src="packageTitleImageURL"
                alt
                class="rounded-0"
                height="240"
                width="450"
              />
              <img
                v-else
                src="@/assets/images/Default Subpackage.jpg"
                class="rounded-0"
                alt
                height="240"
                width="450"
              />
            </span>
          </span>
        </div>
      </div>
      <div class="col-md-12 mt-5 mb-4">
        <div class="mt-3">
          <input
            id="packageImageInput"
            ref="packageImageInput"
            type="file"
            name="file"
            accept="image/*"
            @change="packageImageSelected()"
            style="width: 0.1px; opacity: 0; z-index: -1"
          />
          <div class="mt-4">
            <label
              for="packageImageInput"
              class="text-info"
              style="cursor: pointer"
            >
              {{ $t("extras.createExtra.form.uploadNewImage") }}
            </label>
          </div>
          <div class="text-mute">
            <small>
              {{ $t("packages.editPackage.imageSupportText") }}
              <br />
              <b> Bildgröße 1480px * 840px </b>
            </small>
          </div>
        </div>
      </div>

      <!-- Package Title -->
      <div class="col-md-12">
        <div class="mb-4">
          <label>
            {{ $t("packages.editPackage.titleLable") }}
            <span class="text-danger">*</span>
            <span class="ml-2">
              <p
                v-if="packageTitle"
                class="badge position-absolute"
                :class="{
                  'badge-light': packageTitle.length !== 60,
                  'badge-danger': packageTitle.length === 60,
                }"
              >
                {{ packageTitle.length }} / 60
              </p>
            </span>
          </label>
          <b-form-group>
            <b-form-input
              v-model="packageTitle"
              :placeholder="
                this.$i18n.t('packages.editPackage.titlePlaceholder')
              "
              :maxlength="60"
              :class="{ 'is-invalid': $v.packageTitle.$error }"
            ></b-form-input>
            <div v-if="$v.packageTitle.$error" class="invalid-feedback">
              <span
                v-if="$v.packageTitle.$error && !$v.packageTitle.required"
                >{{ $t("packages.editPackage.titleRequiredMsg") }}</span
              >
            </div>
          </b-form-group>
        </div>
      </div>
      <!-- Package Descrtiption -->
      <div class="col-md-12">
        <div class="mb-4">
          <label>
            {{ $t("packages.editPackage.descriptionLabel") }}
            <span class="text-danger">*</span>
            <span class="ml-2">
              <p
                v-if="packageDescription"
                class="badge position-absolute"
                :class="{
                  'badge-light': packageDescription.length !== 150,
                  'badge-danger': packageDescription.length === 150,
                }"
              >
                {{ packageDescription.length }} / 150
              </p>
            </span>
          </label>
          <textarea
            v-model="packageDescription"
            class="form-control"
            name="textarea"
            rows="4"
            :maxlength="150"
            :placeholder="
              this.$i18n.t('packages.editPackage.descriptionPlaceholder')
            "
            :class="{ 'is-invalid': $v.packageDescription.$error }"
          ></textarea>
          <div v-if="$v.packageDescription.$error" class="invalid-feedback">
            <span
              v-if="
                $v.packageDescription.$error && !$v.packageDescription.required
              "
              >{{ $t("packages.editPackage.descriptionRequiredMsg") }}</span
            >
          </div>
        </div>
      </div>
      <!-- Package Long Descrtiption -->
      <div class="col-md-12">
        <div class="mb-4">
          <label>
            {{ $t("packages.editPackage.longDescriptionLabel") }}
            <span class="text-danger">*</span>
            <span class="ml-2">
              <p
                v-if="packageLongDescription"
                class="badge position-absolute"
                :class="{
                  'badge-light': packageLongDescription.length !== 500,
                  'badge-danger': packageLongDescription.length === 500,
                }"
              >
                {{ packageLongDescription.length }} / 500
              </p>
            </span>
          </label>
          <textarea
            v-model="packageLongDescription"
            class="form-control"
            name="textarea"
            rows="8"
            :maxlength="500"
            :placeholder="
              this.$i18n.t('packages.editPackage.descriptionPlaceholder')
            "
            :class="{ 'is-invalid': $v.packageLongDescription.$error }"
          ></textarea>
          <div v-if="$v.packageLongDescription.$error" class="invalid-feedback">
            <span
              v-if="
                $v.packageLongDescription.$error &&
                !$v.packageLongDescription.required
              "
              >{{ $t("packages.editPackage.descriptionRequiredMsg") }}</span
            >
          </div>
        </div>
      </div>
      <!-- Package Priority -->
      <div class="col-md-12">
        <div class="mb-4">
          <label>
            {{ $t("packages.editPackage.priorityLabel") }}
            <span class="text-danger">*</span>
          </label>
          <b-form-group>
            <b-form-input
              v-model="packagePriority"
              :placeholder="
                this.$i18n.t('packages.editPackage.priorityPlaceholder')
              "
              :class="{ 'is-invalid': $v.packagePriority.$error }"
              type="number"
            ></b-form-input>
            <div v-if="$v.packagePriority.$error" class="invalid-feedback">
              <span v-if="$v.packagePriority.$error && !$v.extraPrice.required">{{
                $t("packages.editPackage.priorityRequiredMsg")
              }}</span>
            </div>
          </b-form-group>
        </div>
      </div>
      <!-- Save Button -->
      <div class="col-md-12">
        <div class="">
          <b-button variant="success" @click="clickSavePackageButton()">
            <i class="bx bxs-save mr-1"></i>
            {{ $t("general.buttons.save") }}</b-button
          >
        </div>
      </div>
    </div>

    <!-- Image Cropper Model -->
    <package-image-cropper-model
      v-if="this.showPackageImageCropModel === true"
      :visible="showPackageImageCropModel"
      @close="showPackageImageCropModel = false"
      :imageFile="packageImageFileToCrop"
      @apply="setCroppedImageToPreview"
    />
  </b-modal>
</template>

<style >
.multiselect__tags {
  font-size: 12px;
}
.multiselect__tag-icon {
  font-weight: 200;
}
.subpackage-image-preview-after-crop {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: none;
  width: 450px;
  height: 200px;
  padding: 0;
  margin: 0;
}
</style>